var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: `${_vm.type === "modal" || _vm.type}`,
      attrs: { id: "omz-attendance" },
    },
    _vm._l(7, function (i) {
      return _c(
        "div",
        { key: i, class: `day day${i} ${_vm.type === "modal" || _vm.type}` },
        [
          _c("img", {
            staticClass: "omc-book",
            attrs: {
              width: "100%",
              src: `${_vm.$s3}/img/${_vm.lang}/event/omz_attend/${_vm.type}/${
                i <= _vm.usrAttend ? "" : "default/"
              }${_vm.img(i)}.webp?${_vm.$ver}`,
            },
          }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }